export default __webpack_public_path__ + "static/media/nona.b4c60170.png";